'use client';

import 'BomdisoftComponents/bomdisoft-backlink/styles.css';
import { bomdisoftProductLabel, getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export type BomdisoftBacklinkProps = {
  annotation?: string;
  annotationAction?: string;
  href: string;
  testId?: string;
};

export const BomdisoftBacklink = ({ annotation, annotationAction, href, testId = 'footer-bomdisoft-backlink' }: BomdisoftBacklinkProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : 'en');

  return (
    <a className='bomdisoft-backlink' data-prodantix={annotation} data-prodantix-action={annotationAction} data-testid={testId} href={href}>
      {bomdisoftProductLabel[language]}
    </a>
  );
};
